/**
 * Checks if the current time format is 12-hour
 * @returns {boolean}
 */
export const checkIs12HoursTimeFormat = () => {
    const timeString = new Date().toLocaleTimeString();

    return timeString.includes('AM') || timeString.includes('PM');
};
